const page ="/menu/page";
const del ="/menu/delete";
const add ="/menu/add";
const edit ="/menu/edit";  

export default {
    page,del,add,edit
  }